import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import {OS} from "../lib/os.js"
import ApiServer from "../ApiServer.js";
import "../util/taskutil.js"
import * as actionMenu from  "../widget/action-menu-registry.ts"
import {ControllerBook} from "../page/ControllerBook.js";
import {MetaTaskCache, TaskListCache} from "../server/objects/TaskBeans.ts"

import TPL_tasklist_list from "../list/tasklist_list.mustache";
import TPL_tasklist from "../list/tasklist.mustache";
import Icons from "../svg/Icons.ts";
import $ from "../$.js";

actionMenu.register({
  tasklistitemmenu(){
    var
      buttons = [],
      taskListBean = TaskListCache.get(this.metaId());

    if(taskListBean.rights.canUpdate){
      buttons.push({onclick:'listedit',svg:Icons.ic_edit,i18nkey:'catsystem.edit'})
    }
    if(taskListBean.mightsort){
      buttons.push({onclick:'togglemenu',svg:Icons.ic_sort,i18nkey:'catsystem.sort.title',
        submenu:[
          {
            onclick:'tasklistsort|alphabetical',
            svg:Icons.ic_sorting_alphabetically,
            i18nkey:'catsystem.sort.alphabetical',
            svgend:taskListBean.taskSorting==='alphabetical'||taskListBean.taskSorting==='alphabeticalReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|duedate',
            svg:Icons.calendar.ic_plan_recipe,
            i18nkey:'catsystem.sort.duedate',
            svgend:taskListBean.taskSorting==='duedate'||taskListBean.taskSorting==='duedateReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|creationdate',
            svg:Icons.ic_sorting_creation_date,
            i18nkey:'catsystem.sort.creationdate',
            svgend:taskListBean.taskSorting==='creationdate'||taskListBean.taskSorting==='creationdateReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|byrecipe',
            svg:Icons.ic_recipes,i18nkey:'catsystem.sort.byrecipe',
            svgend:taskListBean.taskSorting==='byrecipe'||taskListBean.taskSorting==='byrecipeReverse'?Icons.ic_checkmark:undefined
          },
          {
            onclick:'tasklistsort|custom',
            svg:Icons.ic_sorting_custom,i18nkey:'catsystem.sort.custom',
            svgend:taskListBean.taskSorting==='custom'?Icons.ic_checkmark:undefined
          }
        ]})
    } 
    buttons.push({onclick:'tasklistcategorymanage',svg:Icons.list.ic_list_manage_categories,i18nkey:'catsystem.categorymanage'})
    if(taskListBean.taskCategoriesHidden){
      buttons.push({onclick:'tasklistcategoryhide|false',svg:Icons.list.ic_list_show_categories,i18nkey:'catsystem.categoryshow'})
    }else{
      buttons.push({onclick:'tasklistcategoryhide|true',svg:Icons.list.ic_list_hide_categories,i18nkey:'catsystem.categoryhide'})
    }
    if(!taskListBean.system && taskListBean.rights.canShare){
      buttons.push({onclick:'listeditsharing',svg:Icons.ic_group,i18nkey:'catsystem.editsharing'})
    }
    if(taskListBean.completedHidden){
      buttons.push({onclick:'listshowhidecompleted|false',svg:Icons.ic_eye,i18nkey:'catsystem.completedshow'})
    }else{
      buttons.push({onclick:'listshowhidecompleted|true',svg:Icons.ic_eye_off,i18nkey:'catsystem.completedhide'})
    }
    if(taskListBean.ongoing.length){
      buttons.push({onclick:'taskmarkall',svg:Icons.ic_checked,i18nkey:'catsystem.mark'})
    }
    if(taskListBean.complete.length){
      buttons.push({onclick:'taskunmarkall',svg:Icons.ic_checkbox,i18nkey:'catsystem.unmark'})
      buttons.push({onclick:'taskdeletemarked',svg:Icons.ic_delete,i18nkey:'catsystem.clean'})
    }
    buttons.push({onclick:'taskduplicatelist',svg:Icons.ic_duplicate,i18nkey:'catsystem.duplicate'})
    buttons.push({onclick:'print',svg:Icons.ic_print,i18nkey:'actions.print'});
    
    if(taskListBean.rights.canDelete){
      buttons.push({onclick:'listdelete',svg:Icons.ic_delete,i18nkey:'catsystem.delete',color:'var(--red)'})
    } 
    if(OS.canShare){
      buttons.push({onclick:'listshare',svg:Icons.ic_send,i18nkey:'actions.send'})
    }
    
    return {'menu':buttons}
    
  }
})

actionMenu.register({
  async tasklistmenu(){
    return {'menu':[{onclick:'listcreate',svg:Icons.ic_add_plus,i18nkey:'catsystem.create'}]}
  },
  
})

INR.onPage(INR.URL.TASKS,async function(){
  INR.subscribe("CommentChanged",function(isInit){
    amplify.publish("taskNeedRefresh")
  })
  INR.subscribe("pageUnload",function(){
    ApiServer.taskcloselist();
  })
  var CONTROLLER = new ControllerBook(
    $('.pane-left'),
    TPL_tasklist_list,
    $('.pane-main'),
    TPL_tasklist,
    undefined,
    TaskListCache,function(allitems){
    var 
      n = 0,
      p = 0,
      s = 0;
    
    allitems.sort((a,b)=>b.lastActionDate-a.lastActionDate)
    allitems.forEach(taskList=>{
      n++;
      if(taskList.isShared()) s++;
      else p++;
       
    })
    return {items:allitems,countInfo:{n:n,p:p,s:s}}
  });
  INR.subscribe("taskRefreshed",CONTROLLER.onRefresh)
  amplify.publish("taskNeedRefresh")
});